import { default as configure } from '../helpers/configure';

export default function(config) {
    const { apiKey, appConfig = {}, options = {}, breadcrumbsApi = [] } = config;
    // overide required config
    appConfig.enableCrashReporting = true;
    appConfig.pulseCustomLoadTimeEnabled = true;
    appConfig.enablePulse = true;
    appConfig.saveIfOffline = true;
    options.ignore3rdPartyErrors = true;
    options.pulseCustomLoadTimeEnabled = true;
    configure(apiKey, appConfig, options, breadcrumbsApi);
}
